/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_File_LabelInputs */



/**
* | output |
* | --- |
* | "Video File" |
*
* @param {Audio_Description_Export_Video_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_file_label = /** @type {((inputs?: Audio_Description_Export_Video_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофайл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de vídeo")
	return /** @type {LocalizedString} */ ("Video File")
});